<script>
	// Partials
	import WageringProxy from '@/Partials/User/_WageringProxy.svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	import UserStore from '@/Stores/UserStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let user;

	let proxy;
	$: user && getProxy();

	function getProxy() {
		proxy = null;
		UserStore.getProxyTokenForUser(user.id)
			.then((result) => {
				proxy = result;
			})
			.catch((e) => {
				console.error(e);
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'problem occurred getting user token, try refreshing the page',
					timeout: 5
				});
			});
	}
</script>

<div class="p-2 mx-4 bg-gray-100 rounded md:flex md:flex-col">
	<div class="flex items-center px-2 bg-dark-grey text-light">
		<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">
			Phone Bet for {user.first_name}
			{user.last_name}
		</h2>
	</div>
	{#if $ACLStore && ACLStore.granted('users.login') && proxy}
		<div class="max-iframe-height">
			<WageringProxy {proxy} />
		</div>
	{/if}
</div>

<style>
	.max-iframe-height {
		height: calc(var(--vh, 1vh) * 100 - 15rem);
	}
</style>
